// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__GPqcc","social":"Footer_social__Wem6f","logo":"Footer_logo__OIWaN","copyright":"Footer_copyright__0Z-wA"};